import { createRouter, createWebHistory } from "vue-router";
import MainLayout from "../layouts/MainLayout.vue";
import CustomBundleLayout from "../layouts/CustomBundleLayout.vue";
import RenderLayout from "../layouts/RenderLayout.vue";
import MathRender from "../views/MathRender/index.vue";
import SelectRegionLayout from "../layouts/SelectRegionLayout.vue";
import SelectRegion from "../views/SelectRegion/index.vue";
import { getAnalyticsInstance, logAnalyticsEvent } from "../plugins/firebase";

import LoginLayout from "../layouts/LoginLayout.vue";
import Dashboard from "../views/Dashboard.vue";
import Wallet from "../views/Wallet/Wallet.vue";
import CategoryCourses from "../views/Courses/CategoryCourses.vue";
import CategoryCoursesMobile from "../views/Courses/CategoryCoursesMobile.vue";
import MobileStyleCourses from "../views/Courses/MobileStyleCourses.vue";
import WebCourses from "../views/Courses/WebCourses.vue";
import Cart from "../views/Cart/Show.vue";
import InstructorProfile from "../views/InstructorProfile/index.vue";
import InstructorsPage from "../views/Instructors/InstructorsPage.vue";
import InstructorProfilePage from "../views/Instructors/InstructorProfilePage.vue";
import CourseDetails from "../views/CourseDetails/index.vue";
import BundleDetails from "../views/BundleDetails/index.vue";
import Settings from "../views/Settings/index.vue";
import Home from "../views/Home/index.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Logout from "../views/Logout.vue";
import CustomBundle from "../views/CustomBundle/index.vue";
import TermsOfService from "../views/TermsOfService/index.vue";
import PrivacyPolicy from "../views/PrivacyPolicy/index.vue";
import AccountDeletion from "../views/AccountDeletion/index.vue";

// Qbank -------
import QbankHome from "../views/Qbank/Home/index.vue";
import QuizList from "../views/Qbank/QuizList/index.vue";
import QbankSummary from "../views/Qbank/QbankSummary/index.vue";
import QbankSubscribe from "../views/Qbank/Subscribe/index.vue";
import QuizTutor from "../views/Qbank/Quiz/Tutor/index.vue";
import QuizTimed from "../views/Qbank/Quiz/Timed/index.vue";
import QuizReview from "../views/Qbank/Quiz/Review/index.vue";
import Plan from "../views/Qbank/Plan/newPlan.vue";
import CreateCustomTest from "../views/Qbank/NewTest/CreateCustomTest.vue";
import PredefinedTests from "../views/Qbank/NewTest/PredefinedTests.vue";
import QBankLeaderboard from "../views/Qbank/Leaderboard.vue";
//End Qbank

// PrivateSession -------
import PrivateSessionHome from "../views/PrivateSession/Home/index.vue";
import SessionsList from "../views/PrivateSession/SessionsList/index.vue";
import CallsList from "../views/PrivateSession/CallsList/index.vue";
import PendingList from "../views/PrivateSession/PendingList/index.vue";
import PrivateSessionAgora from "../views/PrivateSession/PrivateSessionAgora/index.vue";

//End PrivateSession

//ScholarShips

import ScholarShips from "../views/Scholarships/index.vue";
import ScholarshipDetails from "../views/Scholarships/details.vue";
import ScholarshipsAll from "../views/Scholarships/listall.vue";
import ScholarshipsFavorites from "../views/Scholarships/ScholarshipsFavorites.vue";

//End ScohlarShips

//Start Events
import EventsDetails from "../views/events/details.vue";
import EventsAll from "../views/events/listall.vue";
import EventsFavorites from "../views/events/EventsFavorites.vue";

//End Events

// Chat - Custom implementation with full design control
import ChatMaster from "../views/Chat/Master.vue";
import MessageRequests from "../views/Chat/MessageRequests.vue";
import CreateGroupChat from "../views/Chat/CreateGroupChat.vue";
import FriendsList from "../views/Chat/FriendsList.vue";
import BlockedUsers from "../views/Chat/BlockedUsers.vue";
import ChatSearch from "../views/Chat/ChatSearch.vue";

// MIA AI
import MiaDashboard from "../views/MiaAi/pages/MiaDashboard.vue";
import UnifiedCreateScreen from "../views/MiaAi/pages/UnifiedCreateScreen.vue";
import ProblemSolvingScreen from "../views/MiaAi/pages/ProblemSolvingScreen.vue";
import ProblemDetailsScreen from "../views/MiaAi/pages/ProblemDetailsScreen.vue";
import FlashCardsScreen from "../views/MiaAi/pages/FlashCardsScreen.vue";
import FlashCardDetailsScreen from "../views/MiaAi/pages/FlashCardDetailsScreen.vue";
import StudyModeScreen from "../views/MiaAi/pages/StudyModeScreen.vue";
import SummariesScreen from "../views/MiaAi/pages/SummariesScreen.vue";
import SummaryDetailsScreen from "../views/MiaAi/pages/SummaryDetailsScreen.vue";
import QuestionBanksScreen from "../views/MiaAi/pages/QuestionBanksScreen.vue";

// Stories/Status Feature
import CreateStatus from "../components/stories/CreateStatus.vue";
import StatusHistory from "../components/stories/StatusHistory.vue";

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/render",
    component: RenderLayout,
    children: [
      {
        path: "",
        name: "MathRender",
        component: MathRender,
      },
    ],
  },
  {
    path: "/select-region",
    component: SelectRegionLayout,
    children: [
      {
        path: "",
        name: "SelectRegion",
        component: SelectRegion,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/Dashboard",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/home",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/terms-of-service",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "TermsOfService",
        component: TermsOfService,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/privacy-policy",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "PrivacyPolicy",
        component: PrivacyPolicy,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/account-deletion",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "AccountDeletion",
        component: AccountDeletion,
      },
    ],
  },
  {
    path: "/custome-bundle-share",
    component: CustomBundleLayout,
    children: [
      {
        path: "",
        name: "customebundleshare",
        component: CustomBundle,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/Wallet",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Wallet",
        component: Wallet,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/Cart",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Cart",
        component: Cart,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/CategoryCourses",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CategoryCourses",
        component: CategoryCourses,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/CategoryCoursesMobile",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CategoryCoursesMobile",
        component: CategoryCoursesMobile,
      },
    ],
  },
  {
    path: "/MobileStyleCourses",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MobileStyleCourses",
        component: MobileStyleCourses,
      },
    ],
  },
  {
    path: "/courses",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "WebCourses",
        component: WebCourses,
      },
    ],
  },
  {
    path: "/Settings",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Settings",
        component: Settings,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/course-details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CourseDetails",
        component: CourseDetails,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/bundle-details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "BundleDetails",
        component: BundleDetails,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/login",
    component: LoginLayout,
    children: [
      {
        path: "",
        name: "Login",
        component: Login,
      },
    ],
  },
  {
    path: "/register",
    component: LoginLayout,
    children: [
      {
        path: "",
        name: "Register",
        component: Register,
      },
    ],
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
  },
  {
    path: "/instructor-profile",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "InstructorProfile",
        component: InstructorProfilePage,
      },
    ],
  },
  {
    path: "/instructors",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "InstructorsPage",
        component: InstructorsPage,
      },
    ],
  },
  //PrivateSession ----

  {
    path: "/prvs",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "PrivateSessionHome",
        component: PrivateSessionHome,
      },
    ],
  },
  {
    path: "/sessions-list",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "SessionsList",
        component: SessionsList,
      },
    ],
  },
  {
    path: "/calls-list",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CallsList",
        component: CallsList,
      },
    ],
  },
  {
    path: "/pending-prv-list",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "PendingList",
        component: PendingList,
      },
    ],
  },
  {
    path: "/session-private",
    component: PrivateSessionAgora,
    children: [
      {
        path: "",
        name: "PrivateSessionAgora",
        component: PrivateSessionAgora,
      },
      // Add other main layout routes here
    ],
  },
  //PrivateSession ----

  {
    path: "/qbank",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QbankHome",
        component: QbankHome,
      },
    ],
  },
  {
    path: "/qbank-subscribe",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QbankSubscribe",
        component: QbankSubscribe,
      },
    ],
  },
  {
    path: "/qbank-quiz-timed",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizTimed",
        component: QuizTimed,
      },
    ],
  },
  {
    path: "/qbank-quiz-tutor",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizTutor",
        component: QuizTutor,
      },
    ],
  },
  {
    path: "/qbank-summary",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QbankSummary",
        component: QbankSummary,
      },
    ],
  },
  {
    path: "/qbank-plan",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Plan",
        component: Plan,
      },
    ],
  },
  {
    path: "/qbank-quiz-review",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizReview",
        component: QuizReview,
      },
    ],
  },
  {
    path: "/qbank-list-quiz",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QuizList",
        component: QuizList,
      },
    ],
  },
  {
    path: "/qbank-create-test",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CreateCustomTest",
        component: CreateCustomTest,
      },
    ],
  },
  {
    path: "/qbank-predefined-tests",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "PredefinedTests",
        component: PredefinedTests,
      },
    ],
  },
  {
    path: "/qbank-leaderboard",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "QBankLeaderboard",
        component: QBankLeaderboard,
      },
    ],
  },
  //End -----
  {
    path: "/scholar-ships",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "Scholarships",
        component: ScholarShips,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/scholarships-all",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "ScholarshipsAll",
        component: ScholarshipsAll,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/scholarship-details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "ScholarshipDetails",
        component: ScholarshipDetails,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/scholarships-favorites",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "ScholarshipsFavorites",
        component: ScholarshipsFavorites,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/events-favorites",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "EventsFavorites",
        component: EventsFavorites,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/events-all",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "EventsAll",
        component: EventsAll,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/event-details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "EventsDetails",
        component: EventsDetails,
      },
      // Add other main layout routes here
    ],
  },
  {
    path: "/chat",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "ChatInbox",
        component: ChatMaster,
      },
      {
        path: ":conversationId",
        name: "ChatConversation",
        component: ChatMaster,
        props: true,
      },
    ],
  },
  {
    path: "/chat/requests",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MessageRequests",
        component: MessageRequests,
      },
    ],
  },
  {
    path: "/chat/create-group",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CreateGroupChat",
        component: CreateGroupChat,
      },
    ],
  },
  {
    path: "/chat/friends",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "ChatFriendsList",
        component: FriendsList,
      },
    ],
  },
  {
    path: "/chat/blocked-users",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "ChatBlockedUsers",
        component: BlockedUsers,
      },
    ],
  },
  {
    path: "/chat/search",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "ChatSearch",
        component: ChatSearch,
      },
    ],
  },
  // MIA AI Routes
  {
    path: "/mia",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaDashboard",
        component: MiaDashboard,
      },
    ],
  },
  {
    path: "/mia/create",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaCreate",
        component: UnifiedCreateScreen,
      },
    ],
  },
  {
    path: "/mia/problems",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaProblems",
        component: ProblemSolvingScreen,
      },
    ],
  },
  {
    path: "/mia/problems/details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaProblemDetails",
        component: ProblemDetailsScreen,
      },
    ],
  },
  {
    path: "/mia/flash-cards",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaFlashCards",
        component: FlashCardsScreen,
      },
    ],
  },
  {
    path: "/mia/flash-cards/details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaFlashCardDetails",
        component: FlashCardDetailsScreen,
      },
    ],
  },
  {
    path: "/mia/flash-cards/study",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaStudyMode",
        component: StudyModeScreen,
      },
    ],
  },
  {
    path: "/mia/summaries",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaSummaries",
        component: SummariesScreen,
      },
    ],
  },
  {
    path: "/mia/summaries/details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaSummaryDetails",
        component: SummaryDetailsScreen,
      },
    ],
  },
  {
    path: "/mia/qbanks",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaQBanks",
        component: QuestionBanksScreen,
      },
    ],
  },
  {
    path: "/mia/qbanks/details",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaQBankDetails",
        component: () =>
          import("@/views/MiaAi/pages/QuestionBankDetailsScreen.vue"),
      },
    ],
  },
  {
    path: "/mia/quiz",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaQuiz",
        component: () => import("@/views/MiaAi/pages/MiaQuizScreen.vue"),
      },
    ],
  },
  {
    path: "/mia/qbanks/summary",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaQBankSummary",
        component: () =>
          import("@/views/MiaAi/pages/MiaQBankSummaryScreen.vue"),
      },
    ],
  },
  // MIA AI V2 Routes - Completely isolated from v1
  {
    path: "/ai-v2",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "MiaV2Dashboard",
        component: () => import("@/views/MiaAiV2/pages/MiaV2Dashboard.vue"),
      },
      {
        path: "add-content",
        name: "MiaV2AddContent",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/AddContentV2.vue"),
      },
      {
        path: "select-action",
        name: "MiaV2SelectAction",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/SelectActionV2.vue"),
      },
      {
        path: "polling",
        name: "MiaV2Polling",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/AiPollingV2.vue"),
      },
      {
        path: "summary",
        name: "MiaV2SummaryDetails",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/SummaryDetailsV2.vue"),
      },
      {
        path: "qbank",
        name: "MiaV2TestQBank",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/TestQBankV2.vue"),
      },
      {
        path: "flash-cards",
        name: "MiaV2FlashCardsDetails",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/FlashCardsDetailsV2.vue"),
      },
      {
        path: "flash-cards/study",
        name: "MiaV2FlashCardsStudy",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/FlashCardsStudyV2.vue"),
      },
      {
        path: "solve",
        name: "MiaV2SolveDetails",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/SolveDetailsV2.vue"),
      },
      {
        path: "history",
        name: "MiaV2RequestsList",
        meta: { requiresAuth: true },
        component: () => import("@/views/MiaAiV2/pages/AiRequestsListV2.vue"),
      },
    ],
  },
  // Stories/Status Routes
  {
    path: "/status/create",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "CreateStatus",
        component: CreateStatus,
      },
    ],
  },
  {
    path: "/status/history",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "StatusHistory",
        component: StatusHistory,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth) {
    const token = localStorage.getItem("access_token");
    if (!token) {
      return next({ name: "Login", query: { redirect: to.fullPath } });
    }
  }
  next();
});

router.afterEach((to) => {
  const analytics = getAnalyticsInstance();
  if (analytics && typeof window !== "undefined") {
    logAnalyticsEvent("page_view", {
      page_location: window.location.href,
      page_path: to.fullPath,
      page_title: document.title,
    });
  }
});

export default router;
